import React, { useState, useEffect } from "react";
import "../../../../assets/scss/tests.scss";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import { useLocation, useHistory } from "react-router-dom";
import { decrypt } from "../../../../utility/helpers/encrypt";
import Repository from "../../../../configs/axios/repository";
import AnonymousTest from "./anonymousTest";

const CompleteTest = (props) => {
    const location = useLocation();
    const history = useHistory();
    let isData = true;
    let canDoIt = false;
    const [loadingData, setLoadingData] = useState(false);
    const [toTestingProcess, setToTestingProcess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [loadingforResult, setLoadingForResult] = useState(false);
    const [test, setTest] = useState(false);
    const [showErrorPassed, setShowErrorPassed] = useState(false);
    const queryParameters = new URLSearchParams(window.location.search);
    const token = queryParameters.get("token");
    const [array, setArray] = useState([]);
    const [note_id, setNoteId] = useState(null);
    const [test_name, setTestName] = useState("");
    const [testType, setTestType] = useState("");
    const [noteData, setNoteData] = useState(null);
    const decryptedString = decrypt(token.replace(/ /g, "+"));
    const params = new URLSearchParams(decryptedString);
    const test_id = params.get("test_id");
    const courseName = params.get("course_name");
    const firstName = params.get("first_name");
    const lastName = params.get("last_name");
    const guid = params.get("guid");

    const getTestById = async (test_id, courseName, firstName, lastName) => {
        const result = await Repository.findByEndPoint(
            `api/test/geteTestDataById/${test_id}`
        );
        if (result.data.success == true) {
            return { test: result.data.data, isTest: true };
        }
        setLoadingData(true);
    };
    const findAnonymousResultByGuid = async (guid) => {
        const result = await Repository.findByEndPoint(
            `api/anonymousResult/findAnonymousResultByGuid/${guid}`
        );
        if (result.data.success == true) {
            if (result.data.data == null) {
                setShowError(true);
            } else if (result.data.data.is_passed == true) {
                setShowErrorPassed(true);
            } else {
                setLoadingForResult(true);
                return { is_passed: false };
            }
        }
        setLoadingForResult(true);
    };
    const takeParametrs = async () => {
        if (params) {
            let result1 = await getTestById(
                test_id,
                courseName,
                firstName,
                lastName
            );
            let result2 = await findAnonymousResultByGuid(guid);

            if (result1?.isTest == true && result2?.is_passed == false) {
                setArray(JSON.parse(result1.test.test_content));
                setNoteId(result1.test.note_id.note_id);
                setTestName(result1.test.test_name);
                setTestType(result1.test.test_type);
                setNoteData({
                    title: result1.test.note_id.title,
                    description: result1.test.note_id.description,
                });
                setToTestingProcess(true);
                
            }
        }
        setLoadingData(true);
    };

    useEffect(() => {
        takeParametrs();
    }, []);

    return loadingData && loadingforResult ? (
        <div>
            {toTestingProcess ? (
                <AnonymousTest
                    array={array}
                    testType={testType}
                    note_id={note_id}
                    isData={isData}
                    test_id={test_id}
                    noteData={noteData}
                    canDoIt={canDoIt}
                    courseName={courseName}
                    firstName={firstName}
                    lastName={lastName}
                    test_name={test_name}
                    guid={guid}
                />
            ) : (
                <div className="testBodyDiv homeSection">
                    {showError ? (
                        <div className="d-flex justify-content-center">
                            <h1>
                                The link is incorrect. Please check the link.
                            </h1>
                        </div>
                    ) : (
                        ""
                    )}{" "}
                    {showErrorPassed ? (
                        <div className="d-flex justify-content-center">
                            <h1>The link has expired.</h1>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default CompleteTest;
